import React from 'react';

import './styles.css';

const ContentDivider = ({ position }) => {
    return (
        <div className={`ncs-${position}-divider`}>
            <br />
        </div>
    );
};

export default ContentDivider;
